import { type FC, type ReactElement } from 'react';

import { type FieldComponentProps } from '@core/blocks/edu-flow/components/Fields/types';

import SideChart from './svg/SideChart';
import StraightChart from './svg/StraightChart';

export enum CHART {
  SIDE_CHART = 'side-chart',
  STRAIGHT_CHART = 'straight-chart',
}

const svgMap: Record<CHART, ReactElement> = { 'side-chart': <SideChart />, 'straight-chart': <StraightChart /> };

const ChartPanel: FC<FieldComponentProps> = ({ field }) => svgMap[field.content as keyof typeof svgMap] ?? null;

export default ChartPanel;
